export default function CaptureError({ message }) {
  if (!message) return null;
  return <p className="plate-capture__error" role="alert">{message}</p>;
}
